import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import s from './s.module.less';

type Props = {
    className?: string;
    pausedSince?: string | null;
};

// Small red pill shown next to a provider whose individual Pro-Listing budget is used up.
const BudgetExhaustedTag: React.FC<Props> = ({ className, pausedSince }) => {
    const pausedSinceLabel =
        pausedSince && dayjs(pausedSince).isValid() ? dayjs(pausedSince).format('MMM D, YYYY') : '';
    const tooltip = pausedSinceLabel
        ? `Pro-Listings have been paused since ${pausedSinceLabel} due to insufficient budget. Increase the budget to resume visibility.`
        : 'Pro-Listings have been paused due to insufficient budget. Increase the budget to resume visibility.';

    return (
        <span className={`${s.tag} ${className || ''}`}>
            Budget exhausted
            <Tooltip title={tooltip}>
                <QuestionCircleOutlined className={s.help} />
            </Tooltip>
        </span>
    );
};

export default BudgetExhaustedTag;
